import { apiClient } from './api';
import { Observable, from } from 'rxjs';
import { map, delay } from 'rxjs/operators';
import { ENDPOINTS } from '@/settings/api-settings';
import { IBusinessUnit } from '@/interfaces/business-units';

function getBusinessUnitsStatus(status: any = {}): Observable<IBusinessUnit[]> {
  return from(
    apiClient.get(ENDPOINTS.BUSINESS_UNITS_STATUS, { ativo: status }),
  ).pipe(map((r: any) => (!!r.data ? r.data : [])));
}
function getBusinessUnits(): Observable<IBusinessUnit[]> {
  return from(apiClient.get(ENDPOINTS.BUSINESS_UNITS)).pipe(
    map((r: any) => r.data),
  );
}
function getBusinessUnitsUser(): Observable<IBusinessUnit[]> {
  return from(apiClient.get(ENDPOINTS.BUSINESS_UNITS_USER)).pipe(
    map((r: any) => r.data),
  );
}
function getBusinessUnit(id: string): Observable<IBusinessUnit> {
  return from(apiClient.get(`${ENDPOINTS.BUSINESS_UNITS}/${id}`)).pipe(
    map((r: any) => r.data),
  );
}
function saveBusinessUnit(payload: IBusinessUnit): Observable<any> {
  return from(apiClient.post(ENDPOINTS.BUSINESS_UNITS, payload)).pipe(
    map((r: any) => r.data),
  );
}
function updateBusinessUnit(payload: IBusinessUnit): Observable<any> {
  return from(apiClient.put(ENDPOINTS.BUSINESS_UNITS, payload)).pipe(
    map((r: any) => r.data),
  );
}
function deleteBusinessUnit(id: string): Observable<any> {
  return from(apiClient.delete(`${ENDPOINTS.BUSINESS_UNITS}/${id}`)).pipe(
    map((r: any) => r.data),
  );
}
function saveFile(id: string, payload: any): Observable<any> {
  return from(
    apiClient.putMultipartFormData(
      `${ENDPOINTS.BUSINESS_UNITS}/${id}${ENDPOINTS.BUSINESS_UNITS_FILE}`,
      payload,
    ),
  ).pipe(map((r: any) => r.data));
}
function deleteFile(id: string): Observable<any> {
  return from(
    apiClient.delete(
      `${ENDPOINTS.BUSINESS_UNITS}/${id}${ENDPOINTS.BUSINESS_UNITS_FILE}`,
    ),
  ).pipe(map((r: any) => r.data));
}
export {
  getBusinessUnitsStatus,
  getBusinessUnits,
  getBusinessUnitsUser,
  getBusinessUnit,
  saveBusinessUnit,
  updateBusinessUnit,
  deleteBusinessUnit,
  saveFile,
  deleteFile,
};
